// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2q-DW","content":"Consent_content__8Y3PH","footer":"Consent_footer__3t0gR"};